import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ArrayField, useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { ChipField } from 'shared/react-admin/Fields';

import { ApiClientsMerchantFieldList } from './ApiClientsMerchantFieldList';

type Props = {
  label?: string;
};

export const ApiClientsListMerchantField = ({ label }: Props) => {
  const record = useRecordContext();
  const { createPathWithQuery } = useCreatePathWithQuery();

  if (!record?.merchant && !record?.merchants?.length) {
    return EMPTY_FIELD;
  }

  return record?.merchants?.length ? (
    <ArrayField label={label} source="merchants">
      <ApiClientsMerchantFieldList />
    </ArrayField>
  ) : (
    <Link
      to={createPathWithQuery({
        resource: Resources.Merchants,
        id: record?.merchant?.['@id'],
        type: 'show',
      })}
    >
      <ChipField
        label={label}
        source="merchant.name"
        sx={{ color: 'primary.main', margin: '0!important', cursor: 'pointer' }}
      />
    </Link>
  );
};
